import { drawNoDataMessage } from '../../../utils/d3Utils.ts';
import { PreparedData } from '../prepare-data/prepareData.ts';
import { MeasurementGraphSettings } from '../settings/measurementGraphSettings.ts';
import { createComponents } from './createComponents.ts';
import { getRootElement } from './createRootElement.ts';
import { drawData } from './drawData.ts';


export function renderGraph(
    container: HTMLDivElement,
    preparedData: PreparedData,
    drawBorder: boolean,
    settings: MeasurementGraphSettings,
) {
    const root = getRootElement(container, preparedData, drawBorder);
    if (preparedData.measurements.length === 0) {
        drawNoDataMessage(root);
        return;
    }

    const components = createComponents(container, root, preparedData, settings);
    drawData(components, preparedData, settings);
}
